import { actions } from 'react-redux-form'
import isEmail from 'validator/lib/isEmail.js'
import isURL from 'validator/lib/isURL.js'
import { t } from 'ttag'

import { api } from '@h2/api'

import { numWordsInString } from '../../actions'

export const validateForm = (formPath, validations) => form => dispatch => {
  let validationResponses = []
  /*
   * Validate all of the form fields plus the empty string, which represents
   * form level validations.  Don't use Object.keys(validations) because it won't
   * clear errors for fields that have been removed after errors occurred
   */
  /*
   * console.log("Validating form", form);
   * debugger;
   */
  const fieldKeys = ['', ...Object.keys(form)]

  fieldKeys.forEach(fieldKey => {
    let fullPath = formPath

    if (fieldKey) {
      fullPath = `${formPath}.${fieldKey}`
    }

    //console.log("Full model is", fullModel);
    const fns = validations[fieldKey] || []
    const vfn = validate(fullPath, fns)

    //console.log("Validating", fullPath, "with", fns);
    validationResponses = [...validationResponses, dispatch(vfn(form))]
  })

  return Promise.all(validationResponses).then(allResponses => {
    return allResponses.reduce((v1, v2) => v1 && v2, true)
  })
}

export const validate = (model, fns) => val => (dispatch, getState) => {
  const innerValidate = ([fn, ...rest]) => {
    if (!fn) {
      //console.log("Validation of", model, "succeeded");
      dispatch(actions.setErrors(model, {}))
      dispatch(actions.setPending(model, false))

      return Promise.resolve(true)
    }

    const ret = fn(val, getState)

    return Promise.resolve(ret)
      .then(resp => {
        if (resp) {
          //console.log("Validation of", model, "failed!", resp);
          dispatch(actions.setErrors(model, resp))
          dispatch(actions.setPending(model, false))

          return false
        }

        return innerValidate(rest)
      })
      .catch(e => {
        console.log('Unexpected validation error', e, 'for', model)
        dispatch(actions.setErrors(model, { unexpected: 'An unexpected error occurred' }))
        dispatch(actions.setPending(model, false))

        return Promise.resolve(false)
      })
  }

  //console.log("Starting validation of", model, "with", fns.length, "validators defined");
  dispatch(actions.setPending(model, true))

  return innerValidate(fns)
}

export const stringDefined = str => {
  //console.log("Running stringDefined on", typeof str, "value = ", str);
  return (
    typeof str !== 'undefined' &&
    str !== null &&
    (typeof str !== 'string' || str.trim().length > 0)
  )
}

export const targetField = (fieldName, fn) => {
  return form => {
    const val = form[fieldName]

    return fn(val)
  }
}

export const required = (params = {}) => val => {
  const { unless } = params

  if (!unless) {
    let isValid = stringDefined(val)

    if (val instanceof Array) {
      if (val.length > 0 && val[0] instanceof File) {
        isValid = val[0].name && val[0].name.length > 0
      } else {
        isValid = val.length > 0
      }
    }

    //console.log("Validating stringDefined of", val);
    return isValid ? null : { required: t`Required` }
  }
}

export const minWords = params => val => {
  if (stringDefined(val)) {
    console.log(words, val)
    const { words } = params

    return numWordsInString(val) < words && { minWords: t`Minimum ${words} words` }
  }
}

export const maxWords = params => val => {
  if (stringDefined(val)) {
    const { words } = params

    return numWordsInString(val) > words && { maxWords: t`Maximum ${words} words` }
  }
}

export const minLength = params => val => {
  if (stringDefined(val)) {
    const { length } = params

    return val.length < length && { minLength: t`Minimum ${length} characters` }
  }
}

export const maxLength = params => val => {
  if (stringDefined(val)) {
    const { length } = params

    return val.length > length && { maxLength: t`Maximum ${length} characters` }
  }
}

export const minValue = params => val => {
  if (stringDefined(val)) {
    const { amount } = params
    const intValue = parseInt(val)

    return (
      (!Number.isInteger(intValue) || intValue < amount) && {
        minValue: t`Must be ${amount} or more`
      }
    )
  }
}

export const maxValue = params => val => {
  if (stringDefined(val)) {
    const { amount } = params
    const intValue = parseInt(val)

    return (
      (!Number.isInteger(intValue) || intValue > amount) && {
        maxValue: t`Must be ${amount} or less`
      }
    )
  }
}

export const isDate = params => val => {
  if (stringDefined(val)) {
    const d = isNaN(Date.parse(val))

    return d && { isDate: t`Invalid date` }
  }
}

export const email = params => val => {
  if (stringDefined(val)) {
    return !isEmail(val.trim()) && { email: t`Invalid e-mail address` }
  }
}

export const url = params => val => {
  if (stringDefined(val)) {
    return !isURL(val.trim(), { require_host: false }) && { url: t`Invalid URL` }
  }
}

export const domain = params => val => {
  if (stringDefined(val)) {
    const re = new RegExp(
      /^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/
    )

    return !val.match(re) && { domain: t`Invalid domain` }
  }
}

export const validateName = name => {
  if (stringDefined(name)) {
    if (/^___/.test(name)) {
      return Promise.resolve(t`Invalid username`)
    }

    if (/\s/.test(name)) {
      return Promise.resolve(t`Can not contain spaces`)
    }

    return api
      .fetch('/auth/usernameAvailable', { body: name, method: 'post' })
      .then(available => {
        if (!available) {
          return t`Already in use`
        }
      })
      .catch(() => {
        return Promise.resolve(t`An error occurred while checking availability`)
      })
  }

  return Promise.resolve(t`Required`)
}

export const match = params => form => {
  const { field, against } = params
  const val = form[field]
  //console.log('againstField =', againstField);
  const againstVal = form[against]

  //console.log('val =', val, 'againstVal =', againstVal);
  return (
    stringDefined(val) &&
    stringDefined(againstVal) &&
    val !== againstVal && { match: t`Values don't match` }
  )
}
